export default {
  heading: {
    id: 'product_macbook_processor_modal_2_heading',
    defaultMessage: 'Understanding processors',
  },
  intro: {
    id: 'product_macbook_processor_modal_2_intro',
    defaultMessage:
      'The processor or “CPU” is the brain of your computer, so when choosing one, think about how you’ll use the computer.\n\nFor emails and Netflix, you don’t need the most powerful chip. For gaming or heavy multitasking, it’s worth investing in more brainpower.',
  },
  section1Title: {
    id: 'product_macbook_processor_modal_2_section_1_title',
    defaultMessage: 'How will you use it?',
  },
  section1Item1Title: {
    id: 'product_macbook_processor_modal_2_section_1_item_1_title',
    defaultMessage: 'Everyday use',
  },
  section1Item1Description: {
    id: 'product_macbook_processor_modal_2_section_1_item_1_description',
    defaultMessage:
      'For browsing, streaming, and video calls, mid-range CPU (see below) is more than enough.',
  },
  section1Item2Title: {
    id: 'product_macbook_processor_modal_2_section_1_item_2_title',
    defaultMessage: 'Multitasking',
  },
  section1Item2Description: {
    id: 'product_macbook_processor_modal_2_section_1_item_2_description',
    defaultMessage:
      'When juggling lots of tasks, more cores and higher speeds mean smoother performance.',
  },
  section1Item3Title: {
    id: 'product_macbook_processor_modal_2_section_1_item_3_title',
    defaultMessage: 'Gaming and media creation',
  },
  section1Item3Description: {
    id: 'product_macbook_processor_modal_2_section_1_item_3_description',
    defaultMessage:
      'For video editing, designing, or playing modern games, a stronger processor keeps things fast.',
  },
  section2Title: {
    id: 'product_macbook_processor_modal_2_section_2_title',
    defaultMessage: 'How to tell the difference',
  },
  section2Subtitle1: {
    id: 'product_macbook_processor_modal_2_section_2_subtitle_1',
    defaultMessage: 'Series',
  },
  section2Subtitle1Description: {
    id: 'product_macbook_processor_modal_2_section_2_subtitle_1_description',
    defaultMessage:
      'Choose your laptop series based on what you’ll use the device for. Higher series numbers mean more advanced tasks can be completed.\n\nFor entry-level tasks, look for Core i3 or Ryzen 3. For mid level tasks, like browsing the internet or office work, look for Core i5 or Ryzen 5.\n\nFor more advanced tasks, like gaming and creative work, look for Core i7, Core i9, Ryzen 7, or Ryzen 9.',
  },
  section2Subtitle2: {
    id: 'product_macbook_processor_modal_2_section_2_subtitle_2',
    defaultMessage: 'Generation',
  },
  section2Subtitle2Description: {
    id: 'product_macbook_processor_modal_2_section_2_subtitle_2_description',
    defaultMessage:
      'Newer generations are generally faster and more power efficient. As a rule of thumb, remember that each new generation has about 10% more performance than the previous one of the same brand.',
  },
  section2Subtitle3: {
    id: 'product_macbook_processor_modal_2_section_2_subtitle_3',
    defaultMessage: 'Suffix',
  },
  section2Subtitle3Title1: {
    id: 'product_macbook_processor_modal_2_section_2_subtitle_3_title_1',
    defaultMessage: '(U)',
  },
  section2Subtitle3Title1Description: {
    id: 'product_macbook_processor_modal_2_section_2_subtitle_3_title_1_description',
    defaultMessage: 'Basic use, best for video streaming and web browsing.',
  },
  section2Subtitle3Title2: {
    id: 'product_macbook_processor_modal_2_section_2_subtitle_3_title_2',
    defaultMessage: '(P)',
  },
  section2Subtitle3Title2Description: {
    id: 'product_macbook_processor_modal_2_section_2_subtitle_3_title_2_description',
    defaultMessage:
      'Mid-range performance. Best for moderate to heavy everyday workloads.',
  },
  section2Subtitle3Title3: {
    id: 'product_macbook_processor_modal_2_section_2_subtitle_3_title_3',
    defaultMessage: '(H)',
  },
  section2Subtitle3Title3Description: {
    id: 'product_macbook_processor_modal_2_section_2_subtitle_3_title_3_description',
    defaultMessage:
      'Highest performance built for heavy use like gaming and creativity tools.',
  },
}
